import messages from '../../locale/messages';

const validate = values => {
  const errors = {};

  if (!values.firstName) {
    errors.firstName = messages.firstNameRequired;
  } else if (values.firstName && values.firstName.trim() == '') {
    errors.firstName = messages.blankSpace;
  }

  if (!values.lastName) {
    errors.lastName = messages.lastNameRequired;
  } else if (values.lastName && values.lastName.trim() == '') {
    errors.lastName = messages.blankSpace;
  }

  if (!values.email) {
    errors.email = messages.emailRequired;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values.email)) {
    errors.email = messages.emailInvalid;
  }

  /*if (!values.phoneNumber) {
    errors.phoneNumber = messages.phoneNumberRequired;
  } else if (values.phoneNumber && values.phoneNumber.trim() == "") {
    errors.phoneNumber = messages.blankSpace;
  }*/

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/EditProfileForm/validate.js